import { render } from "./Tehnikad.vue?vue&type=template&id=6e274533&scoped=true"
import script from "./Tehnikad.vue?vue&type=script&lang=js"
export * from "./Tehnikad.vue?vue&type=script&lang=js"

import "./Tehnikad.vue?vue&type=style&index=0&id=6e274533&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e274533"]])

export default __exports__